import Image from 'next/image'
import styles from './TeamPhotoFeed.module.scss'

export default function TeamPhotoFeed(props) {
  const { teamFeedSubheading, teamFeedheading, teamFeedDescription, teamHeadshots } = props.fields
  const centered = props.centered === true

  return (
    <>
      <div className={styles.teamPhotoFeed}>
        <div className={styles.teamPhotoFeedWrapper}>
          {/* Repeater image Field */}
          <div className={styles.imagesContent}>
            {/* The scroll is a CSS animation; its duration scales with the number of headshots */}
            <div className={styles.imagesContentWrapper} style={{ '--headshot-count': teamHeadshots.length }}>
              {/* Duplicate the images to enable seamless scrolling */}
              {teamHeadshots.concat(teamHeadshots).map((headshot, index) => (
                <Image
                  className={styles.headshot}
                  key={index}
                  src={headshot?.headshot?.node.sourceUrl}
                  alt={`Team member ${index + 1}`}
                  width={300}
                  height={300}
                />
              ))}
            </div>
          </div>

          <div className={`${styles.teamPhotoFeedMainContent} ${centered ? styles.contentCentered : ''}`}>
            <p className={styles.subheading}>{teamFeedSubheading}</p>
            <h3 className={styles.heading}>{teamFeedheading}</h3>
            <div className={styles.WYSIWYGWrapper}>
              <div className={styles.WYSIWYG} dangerouslySetInnerHTML={{ __html: teamFeedDescription }}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
